import * as React from 'react'
import { Link } from 'react-router-dom'

import { MergedProps as Props } from '../../containers/contacts'
import HeaderMenuComponent from '../common/headerMenuComponent'
import FooterComponent from '../common/footerComponent'

interface State {
	isFirstLoading: boolean
	questionType: string
}

export default class ContactsComponent extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props)
		this.state = {
			isFirstLoading: true,
			questionType: 'UIUXについて'
		}

		this.onSubmitting = this.onSubmitting.bind(this)
		this.handleQuestionTypeSelectField = this.handleQuestionTypeSelectField.bind(this)
	}

	onSubmitting() {
		this.setState({
			isFirstLoading: false
		})
	}

	handleQuestionTypeSelectField(e: React.FormEvent<HTMLSelectElement>) {
		this.setState({
			questionType: e.currentTarget.value
		})
	}

	renderForm() {
		const { isCreating, handlers } = this.props
		const { onSubmit } = handlers

		return (
			<div>
				<h3>まずはカジュアルにご相談ください。</h3>
				<div className="col-xs-offset-1 col-xs-10 col-sm-offset-2 col-sm-8 form-body">
					<form
						onSubmit={(e) => {
							e.preventDefault()
							this.onSubmitting()
							onSubmit(e)
						}}
					>
						<div className="form-body">
							<div className="col-xs-12 col-sm-12 form-row">
								<div className="col-xs-12 col-sm-3 form-title">相談内容</div>
								<div className="col-xs-12 col-sm-9 form-value">
									<div className="input prefectures">
										<select
											onChange={this.handleQuestionTypeSelectField}
											value={this.state.questionType}
											disabled={isCreating}
										>
											<option value="UIUXについて">UIUXについて</option>
											<option value="開発支援について">開発支援について</option>
											<option value="グロースハックについて">グロースハックについて</option>
											<option value="その他">その他</option>
										</select>
										<input type="hidden" name="questionType" value={this.state.questionType} />
									</div>
								</div>
							</div>
							<div className="col-xs-12 col-sm-12 form-row">
								<div className="col-xs-12 col-sm-3 form-title">会社名</div>
								<div className="col-xs-12 col-sm-9 form-value">
									<input type="text" name="companyName" disabled={isCreating} placeholder="合同会社GENESIS" />
								</div>
							</div>
							<div className="col-xs-12 col-sm-12 form-row">
								<div className="col-xs-12 col-sm-3 form-title">担当者名</div>
								<div className="col-xs-12 col-sm-9 form-value">
									<input type="text" name="staffName" disabled={isCreating} placeholder="山田太郎" />
								</div>
							</div>
							<div className="col-xs-12 col-sm-12 form-row">
								<div className="col-xs-12 col-sm-3 form-title">メールアドレス</div>
								<div className="col-xs-12 col-sm-9 form-value">
									<input type="text" name="email" disabled={isCreating} placeholder="taro.yamada@ge-ne-sis.com" />
								</div>
							</div>
							<div className="col-xs-12 col-sm-12 form-row">
								<div className="col-xs-12 col-sm-3 form-title">電話番号</div>
								<div className="col-xs-12 col-sm-9 form-value">
									<input type="text" name="telephone" disabled={isCreating} placeholder="03-1234-5678" />
								</div>
							</div>
							<div className="col-xs-12 col-sm-12 send">
								<button type="submit" className="send-button noleft" disabled={isCreating}>
									送信する
								</button>
							</div>
						</div>
					</form>
				</div>
			</div>
		)
	}

	renderThanks() {
		return (
			<div className="col-xs-offset-1 col-xs-10 col-sm-offset-2 col-sm-8 thanks-body">
				<div className="thanks-body-inner">
					<div className="col-xs-12 col-sm-12 thanks-row">
						<div className="thanks-image"><img src="img/ic_contact_thanks.png" /></div>
					</div>
					<div className="col-xs-12 col-sm-12 thanks-row">
						<p className="thanks-title">THANK YOU!!</p>
					</div>
					<div className="col-xs-12 col-sm-12 thanks-row">
						<p className="thanks-description">お問い合わせありがとうございました。お問い合わせいただいた内容については、近日中にご連絡させていただきます。今しばらく、お待ちください。</p>
					</div>
					<div className="col-xs-12 col-sm-12 send">
						<Link className="send-button" to="/">閉じる</Link>
					</div>
				</div>
			</div>
		)
	}

	render() {
		const { createSuccess } = this.props
		return (
			<div>
				<HeaderMenuComponent isTopPage={false} />
				<div className="main-visual-contact">
					<div className="row">
						<div className="container-fluid">
							{
								!this.state.isFirstLoading && createSuccess ?
								this.renderThanks()
								: this.renderForm()
							}
						</div>
					</div>
				</div>
				<FooterComponent isTopPage={false} />
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/contacts/index.tsx